module.exports = __webpack_public_path__ + "img/blackLogo.1d5c0152.png";